import { ILocation, IOrganization, IOrganizationType, IVessel, IVesselVisitOrganization } from "@pmis3/master-data-core";
import { IVesselActivity, IVesselTransitStatus, IVesselVisit, IVesselVisitGridItem, VesselActivityType, VesselTransitStatus } from "./model";
import { Data, Guid } from "@pmis3/utils";
import { IVesselMovement } from "../vessel-movement";
import { IVesselStop } from "../vessel-stop";
import { VesselActivityHelper } from "./vesselActivity.helper";

type VesselVisitFieldConstraints = {
    key: keyof IVesselVisit,
    required?: boolean
}

export class VesselVisitHelper {
    static createNewVesselVisit(organization?: IOrganization) {
        let marineAgency;
        let billableParty;
        if (organization) {
            marineAgency = {
                ...organization,
                id: 0,
                vesselVisitId: 0,
                organizationId: organization.id,
                organizationTypeId: 31,
                isAdded: true
            } as IVesselVisitOrganization;
            billableParty = {
                ...organization,
                id: 0,
                vesselVisitId: 0,
                organizationId: organization.id,
                organizationTypeId: 16,
                isAdded: true
            } as IVesselVisitOrganization;
        }

        return {
            id: 0,
            vesselActivities: [],
            isAdded: true,
            organizations: organization ? [marineAgency, billableParty] : [],
        } as IVesselVisit
    }

    static filterVesselVisitByStatus(vesselVisits: IVesselVisit[], status: IVesselTransitStatus) {
        return vesselVisits.filter(vv => vv.status === status)
    }

    private static _getFieldConstraintsForVesselVisit(): VesselVisitFieldConstraints[] {
        return [
            { key: 'vesselId', required: true },
            { key: 'lastPortOfCallId', required: true },
            { key: 'nextPortOfCallId', required: true },
            // { key: 'pilotStationETA', required: false },
            // { key: 'pilotStationETD', required: true }
        ]
    }

    static visitFieldIsValid(field: keyof IVesselVisit, vv: IVesselVisit): boolean {
        const fieldConstraint = this._getFieldConstraintsForVesselVisit().find(fieldConstraint => fieldConstraint.key == field);
        if (!fieldConstraint) return false;

        // if (field == 'pilotStationETA') {
        //     return vv.pilotStationETD && vv[field] ? vv[field] < vv.pilotStationETD : true;
        // }
        // if (field == 'pilotStationETD') {
        //     if (!vv[field]) return false;

        //     const afterPilotEta = vv.pilotStationETA ? vv[field] > vv.pilotStationETA : true;
        //     const beforeFirstMovementEndTime = (
        //         vv.vesselActivities &&
        //         vv.vesselActivities.length > 0 &&
        //         vv[field] &&
        //         vv.vesselActivities[0].estimatedEndTime
        //     )
        //         ? vv[field] < vv.vesselActivities[0].estimatedEndTime
        //         : true;
        //     return afterPilotEta && beforeFirstMovementEndTime;
        // }

        if (fieldConstraint.required) {
            const value = vv[field];
            return value == null || value == undefined ? false : true;
        }

        return true;
    }

    static vesselVisitIsValid(vv: IVesselVisit): boolean {
        return this._getFieldConstraintsForVesselVisit().every(fieldConstraint => this.visitFieldIsValid(fieldConstraint.key, vv));
    }

    private static _markAllAsDeleted<T extends { isAdded?: boolean; isDeleted?: boolean }>(items?: T[]): T[] | undefined {
        return items?.map(item => ({ ...item, isDeleted: true }));
    }

    static withdrawVesselVisit(vv: IVesselVisit): IVesselVisit {
        return {
            ...vv,
            //TODO: some logic to indicate vv itself is deleted?
            organizations: this._markAllAsDeleted(vv.organizations),
            vesselActivities: vv.vesselActivities?.map(vesselActivity => {
                const isMovement = vesselActivity.activityType === VesselActivityType.Movement;

                return {
                    ...vesselActivity,
                    purposes: this._markAllAsDeleted(vesselActivity.purposes),
                    serviceApplications: isMovement
                        ? this._markAllAsDeleted(vesselActivity.serviceApplications)
                        : vesselActivity.serviceApplications,
                    cargoes: isMovement
                        ? this._markAllAsDeleted((vesselActivity as IVesselMovement).cargoes)
                        : (vesselActivity as IVesselMovement).cargoes,
                };
            }),
        };
    }

}